import { StandardContainer } from '@design-system/StandardContainer';
import { ErrorLoadingIcon } from '@/components/icons/ErrorLoadingIcon';

export const ShopUnavailablePage = ({ tab = 'tests' }: { tab?: 'formulas' | 'tests' }) => {
  return (
    <div className="min-h-screen bg-cover bg-center">
      <StandardContainer>
        <div className="h-[calc(100vh-120px)] flex flex-col items-center justify-center">
          <ErrorLoadingIcon className="mb-4" />
          <div className="text-center">
            <div className="flex flex-col gap-2">
              <p className="typography-text-secondary text-primary">
                {tab === 'formulas' ? 'My Formulas are' : 'The Viome Shop is'}{' '}
                not available to you at this time.
              </p>
              <p className="typography-text-secondary text-primary">
                For more information, please contact customer support.
              </p>
            </div>
          </div>
        </div>
      </StandardContainer>
    </div>
  );
};
